module.exports = __webpack_public_path__ + "static/media/(V)_MG_6190_-_Joias_Contenporaneas.78e2e73d.jpg";